// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: 24px;
  background-color: white;
  padding: 5px 20px;
  box-shadow: 0px -4px 15px 0px rgba(13, 71, 161, 0.2509803922);
}
.header .logo {
  height: 50px;
  max-width: 65px;
}
@media (max-width: 992px) {
  .header .logo {
    height: 35px;
  }
}
.header ion-button h4 {
  color: white;
  text-transform: capitalize;
  font-size: 18px;
  padding-left: 10px;
}
@media (max-width: 992px) {
  .header ion-button h4 {
    font-size: 14px;
  }
}
@media (max-width: 992px) {
  .header ion-button ion-icon {
    zoom: 0.7;
  }
}
.header .title {
  font-size: 14px;
  color: #000;
}
.flag-item {
  margin-right: 10px;
  cursor: pointer;
  margin-left: 10px;
}
.flag-item ion-img {
  width: 45px;
  border: 2px solid var(--ion-color-primary);
  border-radius: 50%;
  padding: 2px;
}
@media (max-width: 992px) {
  .flag-item ion-img {
    width: 40px;
  }
}

.block_info {
  display: flex;
  align-items: center;
}

.venue_info_block {
  display: flex;
  align-items: center;
}
@media (max-width: 992px) {
  .venue_info_block {
    display: none;
  }
}
.venue_info_block ion-icon {
  margin-right: 10px;
  zoom: 1.4;
  cursor: pointer;
}
.venue_info_block div {
  cursor: pointer;
}
.venue_info_block div h3 {
  font-size: 18px;
  text-transform: capitalize;
  color: var(--ion-color-secondary);
}
.venue_info_block div p {
  color: var(--ion-color-secondary);
  font-size: 14px;
  padding-top: 5px;
}

.user-login {
  margin: 0px;
  padding: 5px;
  background: #f3f3f3;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.user-login ion-icon {
  zoom: 1.2;
}

.show-basket {
  min-width: 250px;
  position: relative;
}
.show-basket ion-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}
@media (max-width: 992px) {
  .show-basket {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/app-header-menu/app-header-menu.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,WAAA;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EAEA,iBAAA;EACA,6DAAA;AAHD;AAKC;EACC,YAAA;EACA,eAAA;AAHF;ACNE;EDOD;IAIE,YAAA;EADD;AACF;AAIE;EACC,YAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;AAFH;ACjBE;EDeA;IAME,eAAA;EAAF;AACF;ACtBE;EDwBA;IAEE,SAAA;EAAF;AACF;AAGC;EACC,eAAA;EACA,WAAA;AADF;AASA;EACC,kBAAA;EACA,eAAA;EACA,iBAAA;AAPD;AAQC;EACC,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,YAAA;AANF;AC1CE;ED4CD;IAME,WAAA;EAJD;AACF;;AAQA;EACC,aAAA;EACA,mBAAA;AALD;;AAOA;EACC,aAAA;EACA,mBAAA;AAJD;ACzDE;ED2DF;IAIE,aAAA;EAFA;AACF;AAGC;EACC,kBAAA;EACA,SAAA;EACA,eAAA;AADF;AAGC;EACC,eAAA;AADF;AAGE;EACC,eAAA;EACA,0BAAA;EACA,iCAAA;AADH;AAGE;EACC,iCAAA;EACA,eAAA;EACA,gBAAA;AADH;;AAKA;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAFD;AAGC;EACC,SAAA;AADF;;AAIA;EACC,gBAAA;EACA,kBAAA;AADD;AAEC;EACC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;AAAF;AC5GE;EDqGF;IAUE,aAAA;EACA;AACF","sourcesContent":["@import '../../../theme/mixins';\n\n.header {\n\twidth: 100%;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding-inline: 24px;\n\tbackground-color: white;\n\n\tpadding: 5px 20px;\n\tbox-shadow: 0px -4px 15px 0px #0d47a140;\n\n\t.logo {\n\t\theight: 50px;\n\t\tmax-width: 65px;\n\t\t@include mobile {\n\t\t\theight: 35px;\n\t\t}\n\t}\n\tion-button {\n\t\th4 {\n\t\t\tcolor: white;\n\t\t\ttext-transform: capitalize;\n\t\t\tfont-size: 18px;\n\t\t\tpadding-left: 10px;\n\t\t\t@include mobile {\n\t\t\t\tfont-size: 14px;\n\t\t\t}\n\t\t}\n\t\tion-icon {\n\t\t\t@include mobile {\n\t\t\t\tzoom: 0.7;\n\t\t\t}\n\t\t}\n\t}\n\t.title {\n\t\tfont-size: 14px;\n\t\tcolor: #000;\n\t}\n\tapp-burger-btn {\n\t\t// display: block;\n\t\t// margin-left: auto;\n\t\t// margin-right: -20px;\n\t}\n}\n.flag-item {\n\tmargin-right: 10px;\n\tcursor: pointer;\n\tmargin-left: 10px;\n\tion-img {\n\t\twidth: 45px;\n\t\tborder: 2px solid var(--ion-color-primary);\n\t\tborder-radius: 50%;\n\t\tpadding: 2px;\n\t\t@include mobile {\n\t\t\twidth: 40px;\n\t\t}\n\t}\n}\n\n.block_info {\n\tdisplay: flex;\n\talign-items: center;\n}\n.venue_info_block {\n\tdisplay: flex;\n\talign-items: center;\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n\tion-icon {\n\t\tmargin-right: 10px;\n\t\tzoom: 1.4;\n\t\tcursor: pointer;\n\t}\n\tdiv {\n\t\tcursor: pointer;\n\n\t\th3 {\n\t\t\tfont-size: 18px;\n\t\t\ttext-transform: capitalize;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t\tp {\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t\tfont-size: 14px;\n\t\t\tpadding-top: 5px;\n\t\t}\n\t}\n}\n.user-login {\n\tmargin: 0px;\n\tpadding: 5px;\n\tbackground: #f3f3f3;\n\tborder-radius: 50%;\n\twidth: 45px;\n\theight: 45px;\n\ttext-align: center;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcursor: pointer;\n\tion-icon {\n\t\tzoom: 1.2;\n\t}\n}\n.show-basket {\n\tmin-width: 250px;\n\tposition: relative;\n\tion-icon {\n\t\tposition: absolute;\n\t\tleft: 10px;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t}\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
